<!--
 * @Author: 汪俊洪
 * @Date: 2022-10-18 15:49:05
 * @LastEditors: 汪俊洪
 * @LastEditTime: 2023-07-11 10:30:19
 * @Description: 售后服务申请
-->
<template>
  <div class="inner">
    <div class="content top-info">
      <h2>售后服务申请</h2>
      <el-button
        type="primary"
        size="mini"
        :loading="loading"
        @click="handleSave"
        >提交</el-button
      >
    </div>
    <div>
      <h2>
        基本信息
      </h2>
      <el-form :model="input" :rules="rules" class="form" ref="input">
        <el-form-item label="订单编号：" style="width: 33.33%">
          {{ detail.orderCode }}
        </el-form-item>
        <el-form-item label="申请人：" style="width: 33.33%">
          {{ detail.userName }}
        </el-form-item>
        <el-form-item label="申请人电话：" style="width: 33.33%">
          {{ detail.userMobile }}
        </el-form-item>
        <el-form-item label="申请类型：" prop="userAfterSalesType" style="width: 100%">
          <el-select placeholder="请选择" v-model="input.userAfterSalesType" class="select">
            <el-option
              v-for="(item, index) in options"
              :key="index"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="申请原因：" prop="reason" style="width: 100%">
          <el-input
            type="textarea"
            placeholder="请输入内容"
            v-model="input.reason"
            maxlength="500"
            :autosize="{ minRows: 4, maxRows: 6 }"
            resize="none"
            show-word-limit
          >
          </el-input>
        </el-form-item>
        <el-form-item label="附件：" prop="fileOssIds">
          <Upload
            :buttonText="'上传附件'"
            :tip="'单个文件大小不能超过100mb,且上传文件个数不超过20个'"
            :limit="20"
            :action="action"
            @onSuccess="getFileList"
          ></Upload>
        </el-form-item>
        <el-form-item label="备注：" prop="remark" style="width: 100%">
          <el-input
            type="textarea"
            placeholder="请输备注"
            v-model="input.remark"
            maxlength="500"
            :autosize="{ minRows: 4, maxRows: 6 }"
            resize="none"
            show-word-limit
          >
          </el-input>
        </el-form-item>
      </el-form>
      <h2>
        商品明细
      </h2>
      <el-table :data="goodsItemList" border style="width: 100%;">
        <el-table-column
          prop="goodsCode"
          header-align="center"
          align="center"
          label="商品编码"
        >
        </el-table-column>
        <el-table-column
          prop="goodsName"
          header-align="center"
          align="center"
          label="商品名称"
        >
        </el-table-column>
        <el-table-column
          prop="goodsModel"
          header-align="center"
          align="center"
          label="型号"
        >
        </el-table-column>
        <el-table-column
          prop="transactionPrice"
          header-align="center"
          align="center"
          width="110px"
          label="应付单价"
        >
          <template slot-scope="scope">
            {{ scope.row.transactionPrice }}
          </template>
        </el-table-column>
        <el-table-column
          prop="goodsNum"
          header-align="center"
          align="center"
          label="下单数量"
        ></el-table-column>
        <el-table-column
          prop="deliveryNum"
          header-align="center"
          align="center"
          label="发货数量"
        ></el-table-column>
        <el-table-column
          prop="afterSalesNum"
          header-align="center"
          align="center"
          label="申请数量"
        >
          <template slot-scope="scope">
            <el-input-number
              v-model="scope.row.afterSalesNum"
              style="width: 90px !important"
              :controls="false"
              :min="1"
              :max="scope.row.deliveryNum"
              :precision="0"
              @change="()=>changeNum(scope.row)"
              maxlength="10"
              placeholder="申请数量"
            ></el-input-number>
          </template>
        </el-table-column>
        <el-table-column
          prop="afterSalesAmount"
          header-align="center"
          align="center"
          label="退/补总金额"
          width="150"
        >
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import Upload from '@/components/upload/file'
import { mul } from '@/utils/numberComputed'
export default {
  components: {
    Upload
  },
  data () {
    return {
      action: window.SITE_CONFIG['apiURL'] + '/front/fileupload/alioss/upload',
      loading: false,
      input: {
        userAfterSalesType: '',
        reason: '',
        remark: '',
        fileOssIds: []
      },
      goodsItemList: [],
      rules: {
        userAfterSalesType: [
          {
            required: true,
            message: '请选择申请类型',
            trigger: 'change'
          }
        ],
        reason: [
          {
            required: true,
            message: '请输入申请原因',
            trigger: 'blur'
          }
        ]
      },
      options: [
        // 退货退款，仅退款，换货，补发
        {
          label: '退货退款',
          value: '1'
        },
        {
          label: '仅退款',
          value: '2'
        },
        {
          label: '换货',
          value: '3'
        },
        {
          label: '补发',
          value: '4'
        }
      ],
      detail: {}
    }
  },
  created () {
    this.getDetail()
  },
  methods: {
    getFileList (fileList) {
      this.input.fileOssIds = fileList
    },
    // 获取信息
    getDetail () {
      let row = this.$route.query
      const obj = {
        orderId: row.orderId,
        goodsSkuId: row.goodsSkuId,
        deliveryCode: row.deliveryCode
      }
      this.$http.post('/front/consumer/userAfterSales/getAddInfo', obj).then(({ data: res }) => {
        if (res.code === 0) {
          this.detail = res.data
          let goodsItemList = res.data.goodsItemList || []
          goodsItemList.forEach((v) => {
            if (!v.afterSalesNum) {
              v.afterSalesNum = undefined
            }
          })
          this.goodsItemList = goodsItemList
        }
      })
    },
    mul,
    handleSave () {
      this.$refs.input.validate((valid) => {
        if (!valid) {
          return
        }
        if (this.goodsItemList.length === 0 || !this.goodsItemList[0].afterSalesNum) {
          this.$message.warning('请输入申请数量')
          return
        }
        this.submit()
      })
    },
    changeNum (row) {
      row.afterSalesAmount = mul((row.goodsMoney || 0), (row.afterSalesNum || 0))
    },
    submit () {
      let row = this.$route.query
      const obj = {
        orderId: row.orderId,
        skuId: row.goodsSkuId,
        deliveryCode: row.deliveryCode,
        ...this.input,
        goodsItemList: this.goodsItemList,
        platformSource: '2', // 来源
        fileOssIds: this.input.fileOssIds,
        remark: this.input.remark
      }
      this.loading = true
      this.$http.post('/front/consumer/userAfterSales/add', obj).then(({ data: res }) => {
        this.loading = false
        if (res.code === 0) {
          this.$message.success('提交成功')
          this.$router.replace({
            path: '/personalCenter/afterSalesDetail',
            query: {
              id: res.data
            }
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  margin-bottom: 8px;
  padding-bottom: 8px;
  border-bottom: 1px solid #ebeef5;
}

.form {
  display: flex;
  flex-wrap: wrap;
}
</style>
